import React, {Component} from 'react';
import ReactQuill from 'react-quill';
// import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
// import Checkbox from 'material-ui/Checkbox';
import {AnswerCheckbox} from './AnswerCheckbox';
import { inject, observer } from 'mobx-react';

@inject('topicsStore')
@observer
class Questions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      started: true,
      showKeyLearning: false
    };
  }

  componentDidUpdate() {
    const {started} = this.state;

    if (!started) {
      this.setState({started: true});
      this.props.selectQuiz(0);
    }
  }

  startQuiz = () => {
    this.setState({started: true});
    this.props.selectQuiz(0);
  }

  changeQuiz = (e, value, index) => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    const obj = newQuiz[index];
    obj[e.target.name] = value;
    newQuiz[index] = obj;

    this.props.topicsStore.handleChangeQuiz(newQuiz);
  }

  selectQuiz = index => {
    this.props.selectQuiz(index);
  }

  handleNextQuestion = () => {
    const {onNextQuestion, isQuiz} = this.props;
    const {showKeyLearning} = this.state;

    if (isQuiz) {
      onNextQuestion();
    } else {
      if (showKeyLearning) {
        onNextQuestion();
        this.setState({showKeyLearning: false});
      } else {
        this.setState({showKeyLearning: true});
      }
    }
  }

  renderAnswers = (answers) => {
    return (
      <div className="col-12 container-body">
        <div className="inprogress-quiz">
          <div name="correct" className='column justify-content-center'>
            {answers.sort((a, b) => a.id - b.id).map(answer => (
              <div className={`${answer.answer ? 'correct' : 'incorrect'}`}>
                <label>{`${answer.question}: ${answer.answer ? '✔' : 'x'}`}</label>
              </div>
              // <Checkbox
              //   label={answer.question}
              //   checked={answer.answer} //=== option.correct}
              //   value={answer.answer}
              //   id={answer.id}
              //   disabled
              //   className={answer.answer ? 'correct' : 'incorrect'}
              // />
            ))}
          </div>
        </div>
      </div>
    )
  };

  renderCompleted = ({quizResult, completed, id, isQuiz, answers}) => {
    const token = localStorage.getItem('token');
    const completedText = !isQuiz ? 'You have passed the quiz.' : 'You have passed the quiz for this topic';
    const showAnswers = answers.length > 0;

    return (
      <div className="tab-container">
        <div className="row">
          <div className="col-12 container-body">
            <div className="finish-quiz">
              <h2>{quizResult >= 8 || completed ? 'Congratulations!' : 'Better luck next time!'}</h2>
              <h3>{quizResult >= 8 || completed ? completedText : 'Unfortunately you didn’t pass the quiz this time.'}</h3>
              <h4>{quizResult >= 8 || completed ? `You have answered ${quizResult} out of 10 questions correctly` : 'You need to answer at least 8 questions correctly to pass the quiz.'}</h4>
              {showAnswers && this.renderAnswers(answers)}
              {/* { quizResult >= 8 || completed ?
                <a
                  className="btn blue rounded update-btn"
                  style={{
                    marginTop: '40px',
                    backgroundColor: 'white',
                    border: '1px solid #28b5f4',
                    color: '#28b5f4'
                  }}
                  href={`https://finalmedexamprep.ie/api/v1/pdfs/${id}?token=${token}`}
                  target='_blank'
                >
                  View CPD Cert
                </a> :
                <button
                  className="btn blue rounded update-btn"
                  onClick={this.startQuiz}
                >
                  {"try one more time"}
                </button>
              } */}
              {!isQuiz && (quizResult >= 8 || completed) ? (
                <a
                  className="btn blue rounded update-btn"
                  style={{
                    marginTop: '40px',
                    backgroundColor: 'white',
                    border: '1px solid #28b5f4',
                    color: '#28b5f4'
                  }}
                  href={`https://finalmedexamprep.ie/api/v1/pdfs/${id}?token=${token}`} // http://192.81.220.169/api/v1/pdfs/${id}?token=${token} https://finalmedexamprep.ie/api/v1/pdfs/${id}?token=${token}
                  target='_blank'
                >
                  VIEW CKT CERT
                </a>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderQuestions = ({
    answer,
    selectedQuiz,
    quiz,
    onQuestionAnswerEdit,
    submitAnswers
  }) => {
    const {started, showKeyLearning} = this.state;

    return !started ? (
      <div className="tab-container">
        <div className="row">
          <div className="col-12 container-body">
            <div className="start-quiz">
              <p>To pass this quiz, you must answer 8 out of 10 questions correctly.</p>

              <button onClick={this.startQuiz} className="btn blue rounded update-btn">{'Take the CPD Quiz'}</button>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div className="tab-container">
        { quiz &&
          <div className="row">
            <div className="col-12 container-body">
              <div className="inprogress-quiz">
                <div className={`progress-bar n${selectedQuiz + 1}`}>
                  <button disabled onClick={() => this.selectQuiz(0)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(1)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(2)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(3)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(4)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(5)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(6)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(7)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(8)} className="section"></button>
                  <button disabled onClick={() => this.selectQuiz(9)} className="section"></button>
                </div>
                <p className="question">
                  {quiz.question}
                </p>
                <div name="correct" className='row justify-content-center'>
                  {quiz.options.map((option, index) => (
                    <AnswerCheckbox
                      key={index}
                      index={index}
                      option={option}
                      answer={answer}
                      quiz={quiz}
                      showKeyLearning={showKeyLearning}
                      onQuestionAnswerEdit={onQuestionAnswerEdit}
                    />
                  ))}
                </div>
                {showKeyLearning && (
                  <ReactQuill
                    name={ 'key_learnings' }
                    value={ quiz.key_learnings || '' }
                    className="quill-toolbar-disabled"
                    readOnly={true}
                  >
                    <div style={{ width: '100%', height: 'auto', border: 0 }}></div>
                  </ReactQuill>
                )}
                {(showKeyLearning && quiz.explanation) && (
                  <ReactQuill
                    name={ 'explanation' }
                    value={ quiz.explanation || '' }
                    className="quill-toolbar-disabled"
                    readOnly={true}
                  >
                    <div style={{ width: '100%', height: 'auto', border: 0 }}></div>
                  </ReactQuill>
                )}
                <div className="row justify-content-center">
                  <button
                    disabled={!answer[quiz.id]}
                    onClick={selectedQuiz === 9 ? submitAnswers : this.handleNextQuestion}
                    className="btn-new-main rounded update-btn"
                  >
                    Next question
                  </button>
                </div>
                <div className="row justify-content-center">
                  <span className='pass-hint'>You need to answer 8 out of 10 questions to pass the test</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }

  render() {
    return (
      this.props.completed || (this.props.quizResult || this.props.quizResult === 0) ? this.renderCompleted(this.props) : this.renderQuestions(this.props)
    );
  }
}

export default Questions;



// WEBPACK FOOTER //
// ./src/modules/topic/components/Questions.js